module.exports = __webpack_public_path__ + "static/media/boat-img-12.2713c34a.jpg";